<template>
  <div id="Manager" class="fullheight">
    <fe-table
      class="fullheight"
      @load="loadData"
      :data="budget_manager"
      :pageResult="pageResult"
      :selection="true"
      :style="{height: maxHeight + 'px'}"
      quick-search-props="w_tenant_bank_info.f_deposit_bank,w_tenant_bank_info.f_bank_account"
      :show-export="false"
      :show-custom-column="false"
      ref="htTable"
    >
      <template v-slot:search>
        <fe-table-search-panel :divide="3" :label-width="100">
          <fe-table-search-field
            label="账户性质"
            type="select"
            :options="options"
            prop="w_tenant_bank_info.f_account_type"
          />
          <fe-table-search-field
            label="项目编号"
            prop="w_tenant_bank_info.f_project_no"
          />
          <fe-table-search-field
            label="项目名称"
            prop="w_tenant_bank_info.f_project_name"
          />
        </fe-table-search-panel>
      </template>
      <template v-slot:toolbar>
          <el-button size="small" @click="showDialog()" type="primary"
            >添加</el-button
          >
          <fe-delete-button
            url="${portal}/system/tenant_bank_info/"
            :htTable="$refs.htTable"
            class="marginLeft16"
            >删除</fe-delete-button
          >
      </template>
      <template>
        <eco-table-column type="index" width="50" align="center" label="序号" />
        <eco-table-column
          prop="w_tenant_bank_info.f_tenant_name"
          label="户名"
          :sortable="true"
          :sort-by="'w_tenant_bank_info.f_tenant_name'"
          :show-overflow-tooltip="true"
        >
        </eco-table-column>
        <eco-table-column
          prop="w_tenant_bank_info.f_deposit_bank"
          label="开户银行"
          :sortable="true"
          :sort-by="'w_tenant_bank_info.f_deposit_bank'"
          :show-overflow-tooltip="true"
        >
        </eco-table-column>
        <eco-table-column
          prop="w_tenant_bank_info.f_bank_number"
          label="联行号"
          :sortable="true"
          :sort-by="'w_tenant_bank_info.f_bank_number'"
          :show-overflow-tooltip="true"
        >
        </eco-table-column>
        <eco-table-column
          prop="w_tenant_bank_info.f_bank_account"
          label="银行账号"
          :sortable="true"
          :sort-by="'w_tenant_bank_info.f_bank_account'"
          :show-overflow-tooltip="true"
        >
        </eco-table-column>
        <eco-table-column
          prop="w_tenant_bank_info.f_account_type"
          label="账户性质"
          :sortable="true"
          :sort-by="'w_tenant_bank_info.f_account_type'"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.w_tenant_bank_info.f_account_type === 1"
              >基本户</span
            >
            <span v-if="scope.row.w_tenant_bank_info.f_account_type === 2"
              >一般账户</span
            >
            <span v-if="scope.row.w_tenant_bank_info.f_account_type === 3"
              >税款专用户</span
            >
            <span v-if="scope.row.w_tenant_bank_info.f_account_type === 4"
              >其他专用账户</span
            >
            <span v-if="scope.row.w_tenant_bank_info.f_account_type === 5"
              >农民工工资专户</span
            >
          </template>
        </eco-table-column>
        <eco-table-column
          prop="w_tenant_bank_info.f_project_no"
          label="项目编号"
          :sortable="true"
          :sort-by="'w_tenant_bank_info.f_project_no'"
          :show-overflow-tooltip="true"
        >
        </eco-table-column>
        <eco-table-column
          prop="w_tenant_bank_info.f_project_name"
          label="项目名称"
          :sortable="true"
          :sort-by="'w_tenant_bank_info.f_project_name'"
          :show-overflow-tooltip="true"
        >
        </eco-table-column>
        <eco-table-column
          prop="w_tenant_bank_info.f_reserved_seal"
          label="预留印鉴"
          :sortable="true"
          :sort-by="'w_tenant_bank_info.f_reserved_seal'"
          :show-overflow-tooltip="true"
        >
        </eco-table-column>
        <eco-table-column
          prop="w_tenant_bank_info.f_default_account"
          label="默认账号"
          :sortable="true"
          :sort-by="'w_tenant_bank_info.f_default_account'"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.w_tenant_bank_info.f_default_account === 0"
              >否</span
            >
            <span v-if="scope.row.w_tenant_bank_info.f_default_account === 1"
              >是</span
            >
          </template>
        </eco-table-column>
        <eco-table-column
          prop="w_tenant_bank_info.f_status"
          label="账户状态"
          :sortable="true"
          :sort-by="'w_tenant_bank_info.f_status'"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{
              scope.row.status == 0
                ? "正常"
                : scope.row.status == 1
                ? "已注销"
                : ""
            }}
          </template>
        </eco-table-column>
        <eco-table-column label="操作" width="120">
          <template v-slot="{ row }">
            <el-link
              type="primary"
              :underline="false"
              @click="showDialog(row.id)"
              v-if="![5].includes(row.w_tenant_bank_info.f_account_type)"
              >编辑</el-link
            >
          </template>
        </eco-table-column>
      </template>
    </fe-table>
    <eco-sidebar-dialog
    destroy-on-close
      width="28%"
      title="银行信息"
      class="sp-manager__dialog tbkInfoDia"
      :visible="dialogVisible"
      append-to-body
      :before-close="beforeCloseDialog"
    >
      <el-form v-form data-vv-scope="propertyForm" style="padding: 20px">
        <!-- <el-form-item label="公司主体"  label-width="100px">
          <el-select
            v-model="model.company_name"
            placeholder="请输入开户行"
            clearable
            filterable
            @change="setBankCode"
          >
            <el-option
              v-for="item in bankDicData"
              :key="item.key"
              :label="item.name"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>   -->
        <eco-form-item label="公司主体">
          <eco-select
            validate="required"
            v-model="model.company_id"
            placeholder="请输入开户行"
            :options="bankDicData"
            :props="{ key: 'key', value: 'name' }"
            style="width:90%"
            @change="setBankCode"
          ></eco-select>
        </eco-form-item>
        <eco-form-item label="户名">
          <eco-input v-model="model.tenant_name" validate="required" style="width:90%"/>
        </eco-form-item>
        <eco-form-item label="开户银行">
          <eco-input v-model="model.deposit_bank" validate="required" style="width:90%"/>
        </eco-form-item>
        <eco-form-item label="联行号">
          <eco-input v-model="model.bank_number" validate="required" style="width:90%"/>
        </eco-form-item>
        <eco-form-item label="银行账号">
          <eco-input v-model="model.bank_account" validate="required" style="width:90%"/>
        </eco-form-item>
        <eco-form-item label="账号性质">
          <eco-radio
            v-model="model.account_type"
            :options="[
              { key: 1, value: '基本户' },
              { key: 2, value: '一般账户' },
              { key: 3, value: '税款专用户' },
              { key: 4, value: '其他专用账户' }
            ]"
            validate="required"
          />
        </eco-form-item>
        <eco-form-item label="预留印鉴">
          <eco-input v-model="model.reserved_seal" style="width:90%"/>
        </eco-form-item>
        <eco-form-item label="默认账号">
          <eco-radio
            v-model="model.default_account"
            :options="[
              { key: 1, value: '是' },
              { key: 0, value: '否' }
            ]"
            validate="required"
          />
        </eco-form-item>
        <eco-form-item label="账户状态">
          <eco-radio
            v-model="model.status"
            :options="[
              { key: 0, value: '正常' },
              { key: 1, value: '已注销' }
            ]"
            validate="required"
          />
        </eco-form-item>
        <eco-form-item label="注销日期" v-if="model.status == 1">
          <el-date-picker
            value-format="yyyy-MM-dd"
            type="date"
            v-model="model.cancellation_date"
            placeholder="选择日期"
            style="width:90%"
          >
          </el-date-picker>
        </eco-form-item>
        <eco-form-item label="注销原因" v-if="model.status == 1">
          <eco-input v-model="model.cancellation_reason" style="width:90%"/>
        </eco-form-item>
        <eco-form-item label="开户地址">
          <eco-input v-model="model.account_open_address" style="width:90%"/>
        </eco-form-item>
        <eco-form-item label="函证联系人">
          <eco-input v-model="model.confirm_contacts" style="width:90%"/>
        </eco-form-item>
        <eco-form-item label="网银证书">
          <eco-input v-model="model.ol_bank_certificate" style="width:90%"/>
        </eco-form-item>
        <eco-form-item label="证书到期日">
          <el-date-picker
            style="width:90%"
            value-format="yyyy-MM-dd"
            type="date"
            v-model="model.date_due"
            placeholder="选择日期"
          >
          </el-date-picker>
        </eco-form-item>
        <eco-form-item label="备注">
          <eco-input
            type="textarea"
            :row="10"
            style="width:90%"
            v-model="model.remark"
            :maxlength="200"
          />
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
       <el-button @click="beforeCloseDialog">{{
          $t("eip.common.cancel")
        }}</el-button> <fe-submit-button
          :url="saveUrl"
          :model="model"
          :request-method="saveMethod"
          :is-submit="isSubmit"
          scope-name="propertyForm"
          @after-save-data="afterSaveData"
          @before-save-data="beforeSaveData"
          >{{ $t("eip.common.save") }}</fe-submit-button
        >
        
      </div>
    </eco-sidebar-dialog>
  </div>
</template>
<script>
import portal from "@/api/portal.js";

export default {
  components: {},
  props: {
    tenantId: String
  },
  data() {
    return {
      dialogVisible: false,
      isSubmit: true,
      saveUrl: "${portal}/system/tenant_bank_info/?tenantId=" + this.tenantId,
      budget_manager: [],
      pageResult: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      model: {},
      maxHeight: document.body.clientHeight - 180,
      isView: true,
      isEdit: false,
      saveMethod: "POST",
      formConfig: {},
      formList: [],
      options: [
        { key: 1, value: "基本户" },
        { key: 2, value: "一般账户" },
        { key: 3, value: "税款专用户" },
        { key: 4, value: "其他专用账户" },
        { key: 5, value: "农民工工资专户" }
      ],
      bankDicData: [],
    };
  },
  mounted() {
    // this.$validator = this.$root.$validator;
  },
  methods: {
    //保存前置事件
    beforeSaveData() {
      this.isSubmit = true;
      if (this.model.default_account == 1 && this.model.status == 1) {
        this.isSubmit = false;
        this.$message.info("默认账户不可注销！");
      }
    },
    showDialog(id) {
      this.getBank();
      if (id) {
        this.saveMethod = "PUT";
        this.isEdit = true;
        portal.getTenantBankInfo(id).then(response => {
          this.model = response;
          this.dialogVisible = true;
        });
      } else {
        this.model = {};
        this.saveMethod = "POST";
        this.isEdit = false;
        this.dialogVisible = true;
      }
    },
    // 获取法人机构-公司主体
    getBank() {
      this.bankDicData = [];
      if (this.tenantId) {
        this.$http
          .post("${portal}/system/tenant_corporate_info/query?tenantId=" +this.tenantId, {
            pageBean: { page: 1, pageSize: 500, total: 1 }
          })
          .then((resp) => {
            console.log(resp,'接口')
              let response = resp.data;
              let res = response.rows;
              res.forEach((item) => {
                this.bankDicData.push({
                  id: item.id,
                  key: item.id,
                  name: item.company_name
                });
              });
            },
            (error) => {
              reject(error);
            }
          )
          .finally(() => {});
      } else{
        this.bankDicData = [];
        this.pageBean = {
          page: 1,
          pageSize: 50,
          total: 0
        };
      }

    },
    // 主体公司下拉回显
    setBankCode(val) {
      console.log(val,'key')
      const indexTtem = this.bankDicData.find(item => item.key == val)
      if (indexTtem) this.model.company_name=indexTtem.name
      // portal.getCompanyInfo(val).then(response => {
      //   console.log(response,'xxxxx')
      //     if(response){
      //       this.model = response;
      //     } else{
      //       this.model={}
      //       const indexTtem = this.bankDicData.find(item => item.key == val)
      //       if (indexTtem)
      //       console.log(indexTtem,'匹配到的值')
      //       this.model.company_name=indexTtem.name
      //     }
      //   });
    },

    beforeCloseDialog() {
      this.dialogVisible = false;
    },
    loadData(param, cb) {
      if (param && cb) {
        const obj = {
          param: param,
          cb: cb
        };
        sessionStorage.setItem("bankLoadJSON", JSON.stringify(obj));
      }
      if (!param) {
        const session = JSON.parse(sessionStorage.getItem("bankLoadJSON"));
        param = session.param;
        cb = session.cb;
      }
      if (this.tenantId) {
        this.$http
          .post(
            "${portal}/system/tenant_bank_info/query?tenantId=" + this.tenantId,
            param
          )
          .then(
            resp => {
              let response = resp.data;
              let res = response.rows;
              res.forEach(item => {
                item.w_tenant_bank_info = {
                  f_id: item.id,
                  f_ref_id: item.ref_id,
                  f_tenant_name: item.tenant_name,
                  f_deposit_bank: item.deposit_bank,
                  f_bank_number: item.bank_number,
                  f_bank_account: item.bank_account,
                  f_account_type: item.account_type,
                  f_reserved_seal: item.reserved_seal,
                  f_default_account: item.default_account,
                  f_project_name: item.project_name,
                  f_project_no: item.project_no,
                  f_pay_total: item.pay_total,
                  f_collection_total: item.collection_total,
                  f_balance: item.balance,
                  f_status: item.status
                };
              });
              this.budget_manager = res;
              this.pageResult = {
                page: response.page,
                pageSize: response.pageSize,
                total: response.total
              };
            },
            error => {
              reject(error);
            }
          )
          .finally(() => cb());
      } else {
        this.budget_manager = [];
        this.pageResult = {
          page: 1,
          pageSize: 50,
          total: 0
        };
      }
    },
    afterSaveData() {
      setTimeout(() => {
        this.beforeCloseDialog();
        this.$refs.htTable.load();
      }, 500);
    }
  }
};
</script>

<style lang="scss">
#Manager {
  
}
.tbkInfoDia {
  .el-dialog > .el-dialog__body {
    height: calc(100% - 170px) !important;
  }

  .dialog-header-title {
    border-bottom: 1px solid #ebeef5;
    padding-bottom: 10px;
  }

  .dialog-header-title > span {
    border-left: 3px solid #2761ff;
    font-weight: 700;
    font-size: 14px;
    padding-left: 10px;
    color: #666;
  }
}
</style>
